/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import {
    manejadorDialogoGlobal,
    manejadorIndicadorCargaGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import ITipoCuentaBancaria from 'Infotrack@Modelos/administracion/tipoCuentaBancaria/entidades/tipoCuentaBancaria';
import React from 'react';
import TipoCuentaBancariaCM from '../controladorModelo/tipoCuentaBancariaCM';
import { acciones, IEstadoTipoCuentaBancaria } from '../reductorTipoCuentaBancaria';
import TipoCuentaBancariaVista from '../vista/tablaTipoCuentaBancariaVista';

const tipoCuentaBancariaCM = new TipoCuentaBancariaCM();

const TableTipoCuentaBancariaCV: React.FunctionComponent = () => {
    const cargaInicial = React.useRef(true);
    const [tipoCuentaBancarias, setTipoCuentaBancarias] = React.useState<ITipoCuentaBancaria[]>([]);
    const [{ recargarTabla }, dispatch] = useProveedor<IEstadoTipoCuentaBancaria>();

    React.useEffect(() => {
        if (recargarTabla || cargaInicial.current) {
            cargarTipoCuentaBancaria();
            if (recargarTabla) {
                dispatch({ type: acciones.RECARGAR_TABLA });
            }
        }
        cargaInicial.current = false;
    });

    const cargarTipoCuentaBancaria = () => {
        manejadorIndicadorCargaGlobal(true);
        tipoCuentaBancariaCM.consultarTipoCuentaBancaria().then((tipoCuentaBancarias) => {
            setTipoCuentaBancarias(tipoCuentaBancarias);
            manejadorIndicadorCargaGlobal(false);
        });
    };
    const manejarFormulario = (tipoFormulario: TipoFormulario, entidadTipoCuentaBancaria?: ITipoCuentaBancaria) => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: { entidadTipoCuentaBancaria, tipoFormulario } });
    };

    const confirmarEliminacion = (tipoCuentaBancaria: ITipoCuentaBancaria) => {
        manejadorDialogoGlobal({
            accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
            accionConfirmar: () => eliminarTipoCuentaBancaria(tipoCuentaBancaria),
            estado: true,
            mensaje: <Texto id={'alerta.confirmacionEliminacion'} />,
            mostrarCancelar: true,
            tipoDialogo: 'Advertencia',
            titulo: <Texto id="titulo.advertencia" />,
        });
    };
    const eliminarTipoCuentaBancaria = (tipoCuentaBancaria: ITipoCuentaBancaria) => {
        manejadorIndicadorCargaGlobal(true);
        manejadorDialogoGlobal({ estado: false });
        tipoCuentaBancariaCM.eliminarTipoCuentaBancaria(tipoCuentaBancaria).then(() => {
            manejadorIndicadorCargaGlobal(false);
            dispatch({ type: acciones.RECARGAR_TABLA });
        });
    };

    return (
        <TipoCuentaBancariaVista
            tipoCuentaBancarias={tipoCuentaBancarias}
            cargarTipoCuentaBancaria={cargarTipoCuentaBancaria}
            confirmarEliminacion={confirmarEliminacion}
            manejarFormulario={manejarFormulario}
        />
    );
};

export default TableTipoCuentaBancariaCV;
